import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { mobileCSS } from '@measures/responsive'

const StyledTableContainer = styled.div`
  display: grid;
  align-items: flex-start;
  grid-row-gap: 32px;
  margin: 0 24px;

  ${mobileCSS(css`
    margin: 0;
  `)}
`

const TableContainer: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => <StyledTableContainer>{children}</StyledTableContainer>

export default TableContainer
